import React from 'react';
import { Route, BrowserRouter } from 'react-router-dom';
import App from '../App';
import KinhThanh from './kinhthanh/KinhThanh';
import SoSanhChuong from './kinhthanh/SoSanhChuong';
import SoSanhCau from './kinhthanh/SoSanhCau';
import TimKiem from './kinhthanh/TimKiem';

const KinhThanhRouter = () => (
  <BrowserRouter basename="/kinhthanh">
    <Route exact path="/" render={() => <App page={<KinhThanh />} />} />
    <Route path="/kinh-thanh" render={() => <App page={<KinhThanh />} />} />
    <Route path="/so-sanh-chuong" render={() => <App page={<SoSanhChuong />} />} />
    <Route path="/so-sanh-cau" render={() => <App page={<SoSanhCau />} />} />
    <Route path="/tim-kiem" render={() => <App page={<TimKiem />} />} />
  </BrowserRouter>
);

export default KinhThanhRouter;
